export enum TagTypeEnum {
    Analog = 1,
    Discrete = 2,
    String = 3
}
